<template>
  <!-- <div :class="isFocus ? 'sd-search-focus' : 'sd-search'" -->
    <div class="sd-search-focus"
      :style="{ width: width + 'px' }"
      :disabled="disabled"
      :value="value"
      @change="handleChnage">
    <!-- <i class="el-icon-search sd-search-icon" v-if="!isFocus"></i> -->
    <input
      class="sd-search-center"
      :type="type"
      v-model="display"
      :placeholder="placeholder"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="updateValue($event.target.value)"
      @keyup="handleKeyUp"
      :maxlength="maxlength"
    >
    <div class="sd-search-btn" @click="handleSearch">
      <i class="el-icon-search sd-search-icon"></i>
      <!-- <svg class="icon sd-search-btn-icon" aria-hidden="true">
        <use xlink:href="#iconfangdajing-"></use>
      </svg> -->
      {{ searchButtonText }}
    </div>
  </div>
</template>
<style src="./search.scss" lang="scss" scoped></style>
<script>
export default {
  name: 'SdSearch',
  props: {
    value: {
      default () {
        return ''
      }
    },
    type: {
      type: String,
      default () {
        return 'text'
      }
    },
    searchButtonText: {
      type: String,
      default () {
        return '搜索'
      }
    },
    maxlength: {
      type: Number,
      default () {
        return undefined
      }
    },
    disabled: {
      type: [Boolean, String],
      default: function () {
        return false
      },
      id: {
        type: String
      }
    },
    width: {
      type: [String, Number]
    },
    placeholder: {
      type: String,
      default: function () {
        return ''
      }
    },
    isFocus: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  computed: {
    display: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    },
    isIOSWeChat () {
      const ua = window.navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger') && ua.includes('like mac os x')
    },
    handleBlur (evt) {
      if (this.isIOSWeChat()) {
        // window.scrollTo(0, document.documentElement.scrollTop || document.body.scrollTop) 亦可
        document.body.scrollTop = document.body.scrollTop
      }
      this.$emit('blur', evt)
    },
    handleChnage (evt) {
      this.$emit('change', evt)
    },
    handleFocus (evt) {
      this.$emit('focus', evt)
    },
    handleKeyUp (evt) {
      this.$emit('keyup', evt)
    },
    handleSearch (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>



// WEBPACK FOOTER //
// search.vue?08d88f08